import { useRecoilValue } from "recoil"
import { keyframes, styled } from "styled-components"
import { langSelector, langState } from "../../state/langState"
import { B3, T4_en, T4_ko } from "../../style/constant"

const Trading = () => {

  const currentLang = useRecoilValue(langState)
  const Text = useRecoilValue(langSelector)

  return(
    <Container>
      <Wrapper>
        <TextArea currentLang = {currentLang}>
          <Title currentLang = {currentLang}>{Text.trading.title}</Title>
          <Desc currentLang = {currentLang}>{Text.trading.desc}</Desc>
        </TextArea>
        <TradingImg src={"imgs/home/Trading.png"}></TradingImg>
      </Wrapper>
    </Container>
  )
}


export default Trading

type Props = {
  currentLang : boolean
}

const Container = styled.section`
  background:url(/imgs/home/background/trading.jpg) no-repeat center center/cover;
  height:560px;
`

const moving = keyframes`
  0%{
    visibility: hidden;
    right:-50%;
  }
  100%{
    visibility: visible;
    right:0%;
  }
`

const Wrapper = styled.div`
  position:relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width:1328px;
  height:100%;
  margin:0 auto;
  /* background:url(/imgs/home/trading.png) no-repeat right top/auto 711px; */
  ` 

const TradingImg = styled.img`
  position:absolute;
  top:0%;
  right:0%;
  width:735px;
  height:711px;
  animation:${moving} 1.5s ease;
  animation-fill-mode: forwards;
`

const TextArea = styled.div<Props>`
  float:right;
  ${props => props.currentLang ? 
  `

  `:
  `

  `
  }
`

const Title = styled.p<Props>`
  white-space: pre-line;
  ${props => props.currentLang ? 
  `
    ${T4_ko};
    margin:0 0 25px 0;
  `:
  `
    ${T4_en};
    margin: 0 0 14px 0;
  `
  }
`

const Desc = styled.p<Props>`
  color:#fff;
  white-space: pre-line;
  ${props => props.currentLang ? 
  `
    ${B3};
  `:
  `
    ${B3};
  `
  }
`